<template>
  <el-card shadow="always">
    <PaymentFinished ref="finished" :type="payment.type" :value="creditData" :token="id" :customer="customer" :billetId="billetId"
      @redirect="go" @first="active = 0" />
    <el-page-header title @back="$router.replace({ name: 'home' })" content="Pagamento"></el-page-header>
    <br />
    <el-form label-width="160px">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6">
          <el-form-item label="Valor do crédito" prop="value">
            <el-input type="text" v-model="data" :disabled="true" v-if="data" />
            <el-input type="text" v-model="credit" @change="credit = $event" v-money.lazy="money" ref="money" v-else />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-steps :active="active" align-center finish-status="success">
      <el-step title="Pagar com"></el-step>
      <el-step title="Dados para pagamento"></el-step>
      <el-step title="Confirmação"></el-step>
    </el-steps>
    <br />
    <PaymentComplement v-if="active === 1" ref="complement" :data="complement" :type="payment.type" />

    <el-tabs v-model="activeTab" tab-position="top" type="card" v-if="active === 0">
      <!--el-tab-pane name="credit" label="Cartão de Crédito">
        <PaymentCreditCard ref="credit" type="credit" />
      </el-tab-pane-->
      <el-tab-pane name="debit" label="Cartão de Débito">
        <PaymentCreditCard ref="debit" type='debit' />
      </el-tab-pane>
      <el-tab-pane name="pix" label="PIX">
        <PaymentPix ref="pix" />
      </el-tab-pane>
      <!--el-tab-pane name="billet" label="Boleto">
        <PaymentBillet ref="billet" />
      </el-tab-pane-->
    </el-tabs>

    <PaymentCompleted v-if="active === 2" ref="completed" :complement="complement" :payment="payment" />

    <div class="bottom clearfix right">
      <el-button type="info" @click="prev" v-if="active > 0" class="button">Voltar</el-button>
      <el-button type="success" @click="next" class="button">Confirmar</el-button>
    </div>
    <br />
  </el-card>
</template>

<script>
import MoneyMixins from "../../../../mixins/money";
import PaymentCreditCard from './PaymentCreditCard';
import PaymentPix from './PaymentPix';
import PaymentFinished from './PaymentFinished';
import PaymentBillet from './PaymentBillet';
import PaymentComplement from './PaymentComplement';
import PaymentCompleted from "./PaymentCompleted.vue";
import { PaymentService } from "@/services/customers/payment.services";
import { UserService } from "@/services/users/user.services";

export default {
  mixins: [MoneyMixins],
  name: "Payment",
  mounted() {
    const vm = this;
    vm.customer = this.$route.query.customer;
    vm.goto = this.$route.query.type === 'circle' ? 'cockpit.user.billing' : 'prepost.add';
    if (this.$route.query.value) {
      vm.data = this.$route.query.value;
      vm.billetId = this.$route.query.id;
    }
    UserService.me()
      .then((user) => {
        console.log('me', user);
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  computed: {
    creditData() {
      return this.data
        ? +this.data.replace('R$', '').replace(/\./g, '').replace(',', '.')
        : +this.credit.replace('R$', '').replace(/\./g, '').replace(',', '.');
    }
  },
  data() {
    return {
      id: "",
      billetId: '',
      active: 0,
      customer: "",
      goto: "",
      credit: 'R$ 0,00',
      data: '',
      complement: {},
      payment: {},
      activeTab: 'pix',
    };
  },
  components: { PaymentCreditCard, PaymentPix, PaymentBillet, PaymentComplement, PaymentCompleted, PaymentFinished },
  sockets: {
    connect() {
      console.log('connect socket')
    },

    disconnect() {
      console.log('disconnect socket')
    },
    orderPaid(data) {
      console.log('orderPaid')
    }
  },
  methods: {
    go() {
      setTimeout(() => {
        this.$router.push({ name: this.goto });
      }, 5000)
    },
    parseCredit() {
      return this.data
        ? +this.data.replace('R$', '').replace(/\./g, '').replace(',', '.')
        : +this.credit.replace('R$', '').replace(/\./g, '').replace(',', '.');
    },
    next() {
      const vm = this;
      const creditData = this.parseCredit();
      if (creditData <= 0) {
        this.$refs.money.$el.children[0].select();
        return this.$message({
          type: "error",
          message: "É preciso informar um valor para crédito!",
        });
      }
      if (this.active === 1) {
        if (this.$refs.complement.validate()) {
          this.complement = this.$refs.complement.get();
          if (this.payment.type === 'credit' || this.payment.type === 'debit') {
            const expiration = this.payment.month.split('/');
            const loading = vm.$loading(vm.$options.loading);
            PaymentService.token({
              type: "card",
              card: {
                number: this.payment.number.replace(/ /g, ''),
                holder_name: this.payment.name,
                holder_document: this.complement.federalid.replace(/[^0-9A-Za-z]/g, '').toUpperCase(),
                exp_month: +expiration[0],
                exp_year: +expiration[1],
                cvv: this.payment.cvv,
                label: "MaisEnvios",
                billing_address: {
                  zip_code: this.complement.cep,
                  city: this.complement.city,
                  state: this.complement.state,
                  country: "BR",
                  line_1: this.complement.address
                }
              }
            })
              .then((response) => {
                if (response.errors) {
                  return this.$message({ type: "error", message: response.errors });
                }
                vm.id = response.id;
                console.log(vm.$refs.finished)
                vm.$refs.finished.updated();
                this.active++;
              })
              .catch((error) => {
                this.$message({ type: "error", message: error });
              }).finally(() => loading.close())
          } else {
            this.active++;
          }

        }
      } else if (this.active === 0) {
        if (this.$refs[this.activeTab].validate()) {
          this.payment = this.$refs[this.activeTab].get();
          this.active++;
        }
      } else if (this.active === 2) {
        this.$refs.finished.open();
      }
    },
    prev() {
      this.active--;
      if (this.active === 0 && this.complement.federalid) {
        setTimeout(() => {
          if (this.$refs.complement) this.$refs.complement.setup(this.complement);
        }, 200)
      }
    },
  },
}
</script>
